// Single source of truth for the app's preferred display locale, used by every
// Intl.NumberFormat/Intl.DateTimeFormat/toLocale*String() call instead of hardcoding 'en-US'.
// Precedence: profile "Locale" preference (see LocalePreferenceSync in app/providers.tsx) > browser locale > 'en-US'.
let preferredLocaleOverride: string | null = null;

// Guards against garbage/sentinel values (e.g. backend "*" wildcard) reaching Intl.NumberFormat/DateTimeFormat and throwing.
function isValidLocale(locale: string): boolean {
  try {
    Intl.getCanonicalLocales(locale);
    return true;
  } catch {
    return false;
  }
}

/** Sets the user's explicit locale preference (from their profile); pass null/undefined to clear it. */
export function setPreferredLocale(locale: string | null | undefined): void {
  preferredLocaleOverride = locale && isValidLocale(locale) ? locale : null;
}

/** Resolves the locale to use for number/date formatting: profile override > browser locale > 'en-US'. */
export function getPreferredLocale(): string {
  if (preferredLocaleOverride) return preferredLocaleOverride;
  if (typeof navigator !== 'undefined' && navigator.language && isValidLocale(navigator.language)) {
    return navigator.language;
  }
  return 'en-US';
}
